<template>
  <div :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="手机号"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="mybox" :style="{ height: pageHeight+ 'px' }" style="margin-top:46px;">
      <div class="myitem laybox changebox changetel">
        <img src="../assets/sj@3x.png" alt="">
        <p>绑定手机号为{{this.phoneNum}}，若当前号码不可使用或需更改请解绑或更改手机号</p>
        <h3 @click="changeTel"> 更换手机号</h3>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, Col, Row, NavBar, Cell, CellGroup, Button } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Tabbar, TabbarItem, Col, Row, NavBar, Cell, CellGroup, Button)

export default {
  name: 'telhomePage',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Col.name]: Col,
    [Row.name]: Row,
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button
  },
  created () {
    this.phoneNum = localStorage.getItem('phoneNum')
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)// 返回上一页面
    },
    changeTel () {
      this.$router.push({
        path: '/changetelPage'// 跳转页面changetelPage
      })
    }

  },
  computed: {},
  data () {
    return {
      phoneNum: '', // 当前手机号
      pageHeight: window.innerHeight - 46
    }
  }
}
</script>

<style scoped lang="less">
/deep/.van-nav-bar__content {
  height: 46px;
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #A6A6A6;
}

</style>
